import axios from "axios";
import { useEffect, useRef } from "react";
import toast from "react-hot-toast";

function UseAutoLogout(isAuthenticated, timeout = 30 * 60 * 1000) {
    const timerRef = useRef(null);

    const resetTimer = () => {
        const isPublicAssessmentRoute = [
            "/mcq",
            "/start",
            "/invalid",
            "/unauthorized",
        ].some((route) => window.location.pathname.startsWith(route));

        if (isAuthenticated && !isPublicAssessmentRoute) {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            timerRef.current = setTimeout(() => {
                const logout = async () => {
                    let response = await axios.get(
                        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
                        }/api/v1/user/logout`,
                        { withCredentials: true }
                    );

                    if (response.data.success) {
                        toast.success("You Session has expired");
                        window.location.href = "/login";
                    }
                };
                logout();
            }, timeout);
        }
    };

    useEffect(() => {
        const events = ["mousemove", "keydown", "click"];

        events.forEach((event) => {
            window.addEventListener(event, resetTimer);
        });

        resetTimer();

        return () => {
            events.forEach((event) => {
                window.removeEventListener(event, resetTimer);
            });
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [timeout, isAuthenticated]);
}

export default UseAutoLogout;
